// @flow
import env from '../../../environment';
import {getCreator} from '../../../http';

export const endpoints = Object.freeze({
  GET_LIST_AUTHORS: `${env.baseApiUrl}/ui/admin/store/blog/authors`,
  GET_AUTHOR: `${env.baseApiUrl}/ui/admin/store/blog/author`,
});

export const listAuthorsApi = getCreator(endpoints.GET_LIST_AUTHORS);
export const getAuthorApi = getCreator(endpoints.GET_AUTHOR);
